import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';
import { InstMngView } from '../pnel-my-institution/pnel-my-institution.component';

@Component({
  selector: 'view-all-test-sessions',
  templateUrl: './view-all-test-sessions.component.html',
  styleUrls: ['./view-all-test-sessions.component.scss']
})
export class ViewAllTestSessionsComponent implements OnInit {

  public breadcrumb = [];

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_DASHBOARD(),
      this.breadcrumbsService._CURRENT(this.lang.tra('ta_title_mng_test_sess'), this.router.url),
    ];
  }

  getCurrentInstMngView(){
    return InstMngView.ALL_SESSIONS;
  }

}
